export const data = [
  {
    id: 1,
    question: "What is photosynthesis? ",
    answer: "Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy, usually from the sun, into chemical energy stored in glucose (a type of sugar). This process primarily occurs in the chloroplasts of plant cells, which contain a green pigment called chlorophyl. During photosynthesis, plants take in carbon dioxide (CO₂) from the air and water (H₂O) from the soil. Using sunlight as the energy source, they convert these ingredients into glucose and release oxygen (O₂) as a byproduct. The overall equation for photosynthesis can be written as:6CO₂ + 6H₂O + light energy → C₆H₁₂O₆ + 6O₂Photosynthesis is essential for life on Earth, as it provides the oxygen we breathe and forms the base of the food chain. It also plays a critical role in maintaining atmospheric carbon levels and supporting ecosystems across the planet.Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energyvPhotosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energyvPhotosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy  Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy  Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy  Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energyv Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy  Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy  Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy Photosynthesis is the biochemical process by which green plants, algae, and some bacteria convert light energy ",
    board: "CBSE",
    class: "7th",
    year: "2022"
  },
   {
    id: 1,
    question: "What is photosynthesis?",
    answer: "Photosynthesis is the process by which green plants make their own food using sunlight Photosynthesis is the process by which green plants make their own food using sunlight Photosynthesis is the process by which green plants make their own food using sunlight Photosynthesis is the process by which green plants make their own food using sunlight.",
    board: "CBSE",
    class: "8th",
    year: "2025"
  },
  {
    id: 2,
    question: "Define gravity.",
    answer: "Gravity is the force that attracts objects towards the center of the Earth.",
    board: "ICSE",
    class: "9th",
    year: "2020"
  },
  {
    id: 3,
    question: "Explain Newton's First Law.",
    answer: "An object will remain at rest or in uniform motion unless acted upon by an external force.",
    board: "CBSE",
    class: "9th",
    year: "2021"
  },
  {
    id: 4,
    question: "What is the capital of India?",
    answer: "New Delhi is the capital of India.",
    board: "State Board",
    class: "6th",
    year: "2023"
  },
  {
    id: 5,
    question: "Name the process of water cycle.",
    answer: "The water cycle includes evaporation, condensation, and precipitation.",
    board: "CBSE",
    class: "6th",
    year: "2022"
  },
  {
    id: 6,
    question: "Explain the process of digestion.",
    answer: "Digestion is the breakdown of food into smaller components that can be absorbed.",
    board: "ICSE",
    class: "8th",
    year: "2021"
  },
  {
    id: 7,
    question: "What is the Pythagorean Theorem?",
    answer: "In a right-angled triangle, the square of the hypotenuse equals the sum of the squares of the other two sides.",
    board: "CBSE",
    class: "10th",
    year: "2020"
  },
  {
    id: 8,
    question: "Describe the structure of an atom.",
    answer: "An atom consists of protons, neutrons, and electrons.",
    board: "State Board",
    class: "9th",
    year: "2023"
  },
  {
    id: 9,
    question: "What is an ecosystem?",
    answer: "An ecosystem is a community of interacting organisms and their physical environment.",
    board: "CBSE",
    class: "8th",
    year: "2022"
  },
  {
    id: 10,
    question: "Explain Ohm's Law.",
    answer: "Ohm's Law states that the current through a conductor is directly proportional to the voltage across it.",
    board: "ICSE",
    class: "10th",
    year: "2023"
  },
  {
    id: 11,
    question: "What is evaporation?",
    answer: "Evaporation is the process by which water changes from a liquid to a gas.",
    board: "CBSE",
    class: "7th",
    year: "2021"
  },
  {
    id: 12,
    question: "Define democracy.",
    answer: "Democracy is a form of government where the power is vested in the hands of the people.",
    board: "State Board",
    class: "8th",
    year: "2020"
  },
  {
    id: 13,
    question: "What are renewable resources?",
    answer: "Renewable resources are those that can be replenished naturally over time.",
    board: "CBSE",
    class: "6th",
    year: "2021"
  },
  {
    id: 14,
    question: "What is algebra?",
    answer: "Algebra is a branch of mathematics that deals with symbols, letters, and numbers to represent and solve problems involving relationships, patterns, and structures. It is often referred to as a generalized form of arithmetic because it allows us to express mathematical relationships using variables (like x, y, or z) instead of just specific numbers.Algebra is a branch of mathematics that deals with symbols, letters, and numbers to represent and solve problems involving relationships, patterns, and structures. It is often referred to as a generalized form of arithmetic because it allows us to express mathematical relationships using variables (like x, y, or z) instead of just specific numbers. Definition:Algebra is the study of mathematical symbols and the rules for manipulating these symbols to solve equations and understand relationships between quantities.",
    board: "ICSE",
    class: "7th",
    year: "2023"
  },
  {
    id: 15,
    question: "What is the importance of the water cycle?",
    answer: "It distributes water across Earth, supports life, and regulates climate.",
    board: "CBSE",
    class: "6th",
    year: "2020"
  }
];
